import { registerAssetViewerTriggers } from '../widgets/asset-viewer/AssetViewerTriggers.js';
import { WidgetRegistry, utils, UPPY_VENDOR_CSS } from '@nordbox/core';

function registerDynStorageWidgets() {
    registerAssetViewerTriggers();
    // 2026-09-24: просмотр медиа (общий view storage.vsmodule_web.assetViewerView)
    WidgetRegistry.registerLazy("AssetViewer", async () => {
        const mod = await import('../widgets/asset-viewer/AssetViewerWidget.js');
        return {
            ctor: mod.AssetViewerWidget
        };
    }, "im-asset-viewer");
    WidgetRegistry.registerLazy("AssetManager", async () => {
        // 1. грузим css
        //await utils.loadCss(libPathResolver() + "/dyn/AssetManagerWidget.css");
        // 2. динамический импорт самого виджета
        const mod = await import('../widgets/AssetManagerWidget.js');
        // 3. возвращаем конструктор 
        return {
            ctor: mod.AssetManagerWidget
        };
    });
    WidgetRegistry.registerLazy("UppyDashboard", async () => {
        // 1. грузим css
        // 2026-08-22: общая vendor-сборка Uppy из ядра, включает dashboard.
        await utils.loadCss(UPPY_VENDOR_CSS);
        // 2. динамический импорт самого виджета
        const mod = await import('../widgets/UppyDashboardWidget.js');
        // 3. возвращаем конструктор 
        return {
            ctor: mod.UppyDashboardWidget
        };
    });
    WidgetRegistry.registerLazy("NFSplitProject", async () => {
        // 2. динамический импорт самого виджета
        const mod = await import('../widgets/NFSplitProjectWidget.js');
        // 3. возвращаем конструктор 
        return {
            ctor: mod.NFSplitProjectWidget
        };
    }, "nf-splitproject");
}

export { registerDynStorageWidgets };
